<template>
  <div class="contact-float">
    <!-- 电话图标 -->
    <div class="contact-item" @click="togglePhone">
      <div class="icon phone-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 12q-.4 0-.712-.288T18.925 11q-.325-2.325-1.963-3.963T13 5.076q-.425-.05-.712-.35T12 4t.3-.712t.7-.238q3.15.35 5.375 2.575T20.95 11q.05.4-.238.7T20 12m-4.175 0q-.325 0-.575-.225t-.375-.6q-.2-.725-.763-1.287t-1.287-.763q-.375-.125-.6-.375T12 8.15q0-.5.35-.812t.775-.213q1.4.325 2.413 1.338t1.337 2.412q.1.425-.225.775t-.825.35m4.125 9q-3.125 0-6.175-1.362t-5.55-3.863t-3.862-5.55T3 4.05q0-.45.3-.75t.75-.3H8.1q.35 0 .625.238t.325.562l.65 3.5q.05.4-.025.675T9.4 8.45L6.975 10.9q.5.925 1.187 1.787t1.513 1.663q.775.775 1.625 1.438T13.1 17l2.35-2.35q.225-.225.588-.337t.712-.063l3.45.7q.35.1.575.363T21 15.9v4.05q0 .45-.3.75t-.75.3"/></svg>
      </div>
      <div class="tooltip" v-if="showPhone">
        <div class="tooltip-content">
          <p class="phone-number">029-82655470</p>
        </div>
      </div>
    </div>
    
    <!-- 二维码图标 -->
    <div class="contact-item" @click="toggleQrcode">
      <div class="icon qrcode-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M3 11V3h8v8zm2-2h4V5H5zM3 21v-8h8v8zm2-2h4v-4H5zm8-8V3h8v8zm2-2h4V5h-4zm4 12v-2h2v2zm-6-6v-2h2v2zm2 2v-2h2v2zm-2 2v-2h2v2zm2 2v-2h2v2zm2-2v-2h2v2zm0-4v-2h2v2zm2 2v-2h2v2z"/></svg>
      </div>
      <div class="tooltip qrcode-tooltip" v-if="showQrcode">
        <div class="tooltip-content">
          <div class="qrcode-container">
            <!-- 二维码图片路径预留 -->
            <img src="@/assets/qrcode.jpg" alt="联系二维码" class="qrcode-image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactFloat',
  data() {
    return {
      showPhone: false,
      showQrcode: false
    }
  },
  methods: {
    togglePhone() {
      this.showPhone = !this.showPhone;
      this.showQrcode = false;
    },
    toggleQrcode() {
      this.showQrcode = !this.showQrcode;
      this.showPhone = false;
    }
  }
}
</script>

<style scoped>
.contact-float {
  position: fixed;
  right: 20px;
  top: 70%;
  transform: translateY(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-item {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.icon {
  width: 50px;
  height: 50px;
  background-color: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
}

.icon:hover {
  background-color: #218838;
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.tooltip {
  position: absolute;
  right: 65px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 1;
  visibility: visible;
  transition: all 0.3s ease;
}

.tooltip::after {
  content: '';
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent #ffffff;
}

.tooltip-content {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
}

.phone-number {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.qrcode-tooltip {
  right: 70px;
}

.qrcode-container {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-float {
    right: 10px;
  }
  
  .icon {
    width: 45px;
    height: 45px;
  }
  
  .tooltip {
    right: 60px;
  }
  
  .qrcode-tooltip {
    right: 65px;
  }
  
  .qrcode-container {
    width: 130px;
    height: 130px;
  }
}
</style>